//require('./bootstrap');

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    dsn: window.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: window.SENTRY_TRACES_SAMPLE_RATE,
    debug: false,
    attachStacktrace: true,
});

window.trackGoal = (goal, fathomData = null) => {

    // Ha meg nem lenne betoltve a library, akkorse okozzon gondot
    if (window.fathom) {
        //window.fathom.trackEvent(goal, fathomData);
    }
}

